// import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
    // state,mutations,actions
    state: {//要设置的全局访问的state对象
        showFooter: true,
        changableNum: 0,
        innerHeight: window.innerHeight,
        //要设置的初始属性值
    },
    mutations: {
        // 处理状态
        increment(state, payload) {
            state.changableNum += payload || 1;
        },
        setHeight: (state, height) => {
            state.innerHeight = height
        }
    },
    getters: {
        getHeight: (state) => {
            return `height:${state.innerHeight}px;`
        }
    },
    actions: {
        increment(context, data) {
            context.commit('increment', data)
        }
    }
});

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js